module.exports = __webpack_public_path__ + "static/media/globe-zoom.87abc493.mp4";